































import Vue from 'vue';
import Component from 'vue-class-component';
import { loader, user } from '@/modules/shared/shared/store/namespaces';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { UserActions } from '@/modules/users/store/user.actions';

@Component({
    name: 'logout-modal',
})
export default class LogoutModal extends Vue {
    opened: boolean = false;

    openModal() {
        this.opened = true;
    }

    closeModal() {
        this.opened = false;
    }

    async logout() {
        this.closeModal();
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        await this.logoutUser();
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
        localStorage.clear();
        this.$router.push({ name: 'login' });
        this.$router.go(0);
    }

    @user.Action(UserActions.LOG_OUT)
    logoutUser!: () => Promise<void>;
}
